import { useChatStartersCRUDActions } from '@mm/state/actions/ChatStartersCRUDActinos';
import { usePromoterCRUDActions } from '@mm/state/actions/PromoterCRUDActions';
import modalActions from '@mm/state/modules/modalsState/actions';
import { UIChatStarterType } from '@mm/state/reducers/chatStarters';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

export const useDeleteChatStarter = (
  deleteWithPromoterCRUDAction?: boolean,
) => {
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const chatStartersCRUDActions = useChatStartersCRUDActions();
  const promoterCRUDActions = usePromoterCRUDActions();

  const dispatch: Dispatch<StoreState> = useDispatch();

  const openDeleteConfirmModal = (
    starter: UIChatStarterType,
    deleteCallback: () => any,
  ) =>
    dispatch(
      modalActions.openDeleteConfirmModal({
        headerText: `Are you sure you want to delete this ${starter.name}?`,
        deleteCallback,
      }),
    );

  const deleteChatStarter = (starter: UIChatStarterType) => {
    if (activeChatbotId) {
      return new Promise<void>(resolve => {
        openDeleteConfirmModal(starter, async () => {
          if (deleteWithPromoterCRUDAction) {
            await promoterCRUDActions.delete({
              botId: activeChatbotId,
              id: starter.id,
            });
          } else {
            await chatStartersCRUDActions.deleteByKindAndId(
              activeChatbotId,
              starter.kind,
              starter.id,
            );
          }
          resolve();
        });
      });
    }
  };

  return { deleteChatStarter };
};
